import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalJourneyDetail } from "./types";

// GET /api/portal/journeys/:assignmentId — journey instance detail
// aggregate (assignment + journey + ordered progress rows with task
// joined). 404 surfaces via ApiClientError(404) and is rendered by the
// page's error block.

export function useJourneyInstanceDetail(assignmentId: string | null) {
  return useQuery<PortalJourneyDetail>({
    queryKey: queryKeys.portal.journeys.detail(assignmentId ?? ""),
    queryFn: () =>
      apiFetch<PortalJourneyDetail>(`/portal/journeys/${assignmentId}`),
    enabled: !!assignmentId,
  });
}
